import { FinEnvironmentName, IFinEnvironment } from './environment-types';

export const environment: IFinEnvironment = {
  name: 'ingdemo' as FinEnvironmentName,
  production: true,
  isSaaSProject: true,

  api: {
    gatewayWSUrl: 'wss://gateway.services.ing.scfplatform.finverity.com/graphql',
    gatewayUrl: 'https://gateway.services.ing.scfplatform.finverity.com/graphql',
    SSOUrl: 'https://sso.services.ing.scfplatform.finverity.com',
    fileServerUrl: 'https://fileuploader.services.ing.scfplatform.finverity.com/files',
    currenciesUrl: 'https://gateway.services.ing.scfplatform.finverity.com/utils/currency-config',
    userDocumentsUrl: 'https://sso.services.ing.scfplatform.finverity.com/utils/document-signs',
    // TODO: to be updated - replace ds-testing URL with a proper environment URL
    instrumentsUploadTemplateUrl:
      'https://ingdemo-config-files.s3.eu-west-2.amazonaws.com/public-assets/xslx-templates/bulk_instrument_upload.xlsx',
    customersBulkUploadTemplateUrl:
      'https://ingdemo-config-files.s3.eu-west-2.amazonaws.com/public-assets/xslx-templates/bulk_customer_upload_template.xlsx',
    leadsBulkUploadTemplateUrl:
      'https://ingdemo-config-files.s3.eu-west-2.amazonaws.com/public-assets/xslx-templates/bulk_customer_upload_template.xlsx',
    uploadingLeadsForSelfOnboardingTemplateUrl:
      'https://ingdemo-config-files.s3.eu-west-2.amazonaws.com/public-assets/xslx-templates/self_onboarding_upload_template.xlsx',
    integrationDocumentationUrl: 'https://gateway.services.ing.scfplatform.finverity.com/v1/api/integration-docs',
    fullAPIReferenceUrl: 'https://gateway.services.ing.scfplatform.finverity.com/v1/api/docs',
    rateLimiterHeader: '',
    maxUserInactivityMinutes: 60,
  },
  platform: {
    title: 'ING Platform',
    company: 'ING',
    displayUrl: 'ing.com',
    companyAddress: '',
    logo: {
      default: { src: 'assets/logo/logo.svg', width: 172, height: 44 },
      login: { src: 'assets/logo/logo-login.svg', width: 293, height: 72 },
      collapsedSidebar: { src: 'assets/logo/logo-sidebar-collapsed.svg', width: 52, height: 44 },
    },
    faviconUrl: 'assets/favicon/favicon.ico',
    email: 'support@ing.scfplatform.finverity.com',
    validators: [
      { rule: 8, name: 'At least 8 characters long', type: 'min' },
      { rule: /[A-Z]/, name: 'At least 1 uppercase letter', type: 'regex' },
      { rule: /[a-z]/, name: 'At least 1 lowercase letter', type: 'regex' },
      { rule: /\d/, name: 'At least 1 numeric digit', type: 'regex' },
      {
        rule: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/,
        name: 'At least 1 special character (e.g., !@#$%^&*)',
        type: 'regex',
      },
      { rule: /^\S*$/, name: 'No spaces', type: 'regex' },
    ],
    helpLink: 'https://support.finverity.com/kb/guide/en/landing-page-Z0IncfcZbi/Steps/3514119',
    isSsoAuthEnabled: false,
    locale: 'en-GB',
  },
  sentry: {
    enabled: false,
    dsn: 'https://aea0ee4f0b1b49f6b18d5d15aeda5420@o4504480764723200.ingest.sentry.io/4504519285538816',
  },
  firebase: {
    appName: 'FINVERITY',
    apiKey: 'AIzaSyAP2IlVBE8E3ItzeX6e9FkH0GH2mT9GClc',
    authDomain: 'finverity-staging.firebaseapp.com',
    databaseURL: 'https://finverity-staging.firebaseio.com',
    projectId: 'finverity-staging',
    storageBucket: 'finverity-staging.appspot.com',
    messagingSenderId: '1037880577124',
    appId: '1:1037880577124:web:3dd9469e015bef2ffe2371',
    measurementId: 'G-M90YF15270',
  },
  stonly: {
    enabled: false,
    widgetId: null,
  },
};
